//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import * as _ from 'underscore'
import { LocalizationHelper } from '../../helpers'

import { Enums } from '../../models/common'

import { ColumnModel } from '../../modules/api/api.models'

import { GridService, GRID_SERVICE_NAME } from '../grid'


//#region Public Types

export const ORDER_ADD_SERVICE_NAME = 'OrderAddService'
export const ORDER_ADD_SERVICE_PROVIDER_NAME = 'OrderAddServiceProvider'

//#endregion


export class OrderAddService {

    //#region Consts

    public static get LOG_PREFIX(): string { return '[SIMAX.Services.Order.Add]' }


    //#endregion


    //#region Ctor

    constructor(
        private gridSerivce: GridService
    ) { }

    //#endregion


    //#region Columns

    public getOrderContentColumns(removeButtonOptionsFunc: (e: any) => DevExpress.ui.dxButtonOptions): ColumnModel[] {
        const columns: ColumnModel[] = []

        const articleColumn: ColumnModel = new ColumnModel()

        articleColumn.idName = 'article'
        articleColumn.name = 'article'
        articleColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Article)
        articleColumn.type = Enums.DataTypeClass.Text

        columns.push(articleColumn)

        const amountColumn: ColumnModel = new ColumnModel()

        amountColumn.idName = 'amount'
        amountColumn.name = 'amount'
        amountColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Amount)
        amountColumn.type = Enums.DataTypeClass.Integer
        amountColumn.width = 70

        columns.push(amountColumn)

        const noteColumn: ColumnModel = new ColumnModel()

        noteColumn.idName = 'notes'
        noteColumn.name = 'notes'
        noteColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Notes)
        noteColumn.type = Enums.DataTypeClass.Text

        columns.push(noteColumn)

        if (removeButtonOptionsFunc != null) {
            const removeColumn: ColumnModel = this.gridSerivce.getToolbarColumn((gridData: any) => {
                return {
                    items: [{
                        widget: 'dxButton',
                        options: removeButtonOptionsFunc(gridData)
                    }]
                }
            })

            removeColumn.width = 70

            columns.push(removeColumn)
        }

        return columns
    }

    //#endregion
}


export class OrderAddServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [
        GRID_SERVICE_NAME, function (gridSerivce: GridService) {
            return new OrderAddService(gridSerivce);
        }]

    //#endregion
} 